module.exports = __webpack_public_path__ + "../resources/images/mail_sprite-78bfb4e2e91d3febd6d005e72a5aa6fc.png";